import { RDDairySoilsEnrollment, RDEnrolledOtherCarbon } from '@cibo/core'
import { ResourceDetailFeature } from '@cibo/ui'
import { useTranslation } from 'react-i18next'
import { CheckboxBooleanYearRollupEditor } from '../CheckboxBooleanYearRollupEditor'

export const EnrolledOtherCarbon: ResourceDetailFeature<RDEnrolledOtherCarbon> = {
  traitId: 'enrolledOtherCarbon',
  TaskEditor: (props: any) => {
    const { t } = useTranslation('@cibo/landmanager/EnrolledOtherCarbon')

    return (
      <CheckboxBooleanYearRollupEditor
        traitId="enrolledOtherCarbon"
        detailKey="result"
        {...props}
        title={t('question')}
      />
    )
  },
}

/** @deprecated -- do not remove until product has confirmed  */
export const DairySoilsEnrollment: ResourceDetailFeature<RDDairySoilsEnrollment> = {
  traitId: 'dairySoilsEnrollment',
  TaskEditor: (props: any) => {
    const { t } = useTranslation('@cibo/landmanager/EnrolledOtherCarbon')

    return (
      <CheckboxBooleanYearRollupEditor
        traitId="dairySoilsEnrollment"
        detailKey="result"
        {...props}
        title={t('question')}
      />
    )
  },
}
